import { useQuery } from '@tanstack/react-query'

import { getLanguages } from '@/clients/gg/languages'

export function useLoadLanguages(enabled = true) {
	const { data, isLoading } = useQuery({
		queryKey: ['countries/languages'],
		queryFn: getLanguages,
		enabled,
		staleTime: Infinity,
	})

	return { data, isLoading }
}
